module.exports = __webpack_public_path__ + "img/solution_sheet_bg.cfcffca3.png";